import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { Pencil } from 'lucide-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'EditButton',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "edit",
    size: "xs"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_unref(Pencil), { class: "size-3" })
    ]),
    _: 3
  }))
}
}

})